<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            width="30%"
            :visible.sync="viewData.visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px" class="ma-dialog-form">
            <el-form-item label="类型" prop="type">
                <el-radio-group v-model="dataForm.type">
                    <el-radio v-for="(type, index) in dataForm.typeList" :label="index" :key="index">{{ type }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input v-model="dataForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="上级菜单" prop="parentName">
                <el-input v-model="dataForm.parentName" ref="parentName" :readonly="true" placeholder=""
                          class="menu-list__input"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.type === 1" label="菜单路由" prop="url">
                <el-input v-model="dataForm.url" placeholder="菜单路由"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.type === 2" label="权限标识" prop="perms">
                <el-input v-model="dataForm.perms" placeholder="多个用逗号分隔, 如: user:list,user:create"></el-input>
            </el-form-item>
            <el-form-item v-if="dataForm.type !== 2" label="排序号" prop="orderNum">
                <el-input-number v-model="dataForm.orderNum" controls-position="right" :min="0"
                                 label="排序号"></el-input-number>
            </el-form-item>
            <el-form-item v-if="dataForm.type !== 2" label="菜单图标" prop="icon">
                <el-input v-model="dataForm.icon" placeholder="菜单图标名称"
                          class="icon-list__input"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
            </el-form-item>
        </el-form>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right;">
                <el-button size="small" @click="viewData.visible = false">取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">确定
                </el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
    import {getMenuActionById, createMenuAction, editMenuAction} from '@/controller/sys'
    export default {
        data() {
            var validateUrl = (rule, value, callback) => {
                if (this.dataForm.type === 1 && !/\S/.test(value)) {
                    callback(new Error('菜单URL不能为空'))
                } else {
                    callback()
                }
            }
            return {
                viewData: {
                    visible: false,
                    width: ''
                },
                dataForm: {
                    id: 0,
                    type: 0,
                    typeList: ['目录', '菜单', '按钮'],
                    name: '',
                    parentId: 0,
                    parentName: '',
                    parentPath: '',
                    url: '',
                    perms: '',
                    orderNum: 0,
                    icon: '',
                    remark: '',
                    iconList: []
                },
                dataRule: {
                    name: [
                        {required: true, message: '菜单名称不能为空', trigger: 'blur'}
                    ],
                    parentName: [
                        {required: true, message: '上级菜单不能为空', trigger: 'change'}
                    ],
                    url: [
                        {validator: validateUrl, trigger: 'blur'}
                    ]
                }
            }
        },
        mounted() {
        },
        methods: {
            init(id, parentId, parentName, parentPath) {
                this.dataForm.id = id || 0
                this.viewData.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if(!this.dataForm.id){
                        this.dataForm.typeList = parentId ? ['目录', '菜单', '按钮'] : ['目录']
                        this.dataForm.type = parentId ? 1 : 0
                        this.dataForm.parentId = parentId ? parentId : 0
                        this.dataForm.parentName = parentName ? parentName : '根目录'
                        this.dataForm.parentPath = parentPath ? parentPath : ''
                    }else {
                        this.dataForm.typeList = ['目录', '菜单', '按钮']
                        getMenuActionById({},this.dataForm.id).then(data => {
                            this.dataForm.type = data.body.permissionType - 1
                            this.dataForm.name = data.body.permissionName
                            this.dataForm.parentId = data.body.parentId
                            this.dataForm.parentName = data.body.parentName
                            this.dataForm.url = data.body.routerUrl
                            this.dataForm.perms = data.body.expression
                            this.dataForm.orderNum = data.body.sortNo
                            this.dataForm.icon = data.body.icon
                            this.dataForm.remark = data.body.remark
                        })
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let params = {
                            'id': this.dataForm.id || undefined,
                            'permissionName': this.dataForm.name,
                            'parentId': this.dataForm.parentId,
                            'permissionType': this.dataForm.type + 1,
                            'routerUrl': this.dataForm.url,
                            'expression': this.dataForm.perms,
                            'sortNo': this.dataForm.orderNum,
                            'icon': this.dataForm.icon,
                            'remark': this.dataForm.remark
                        }
                        if(this.dataForm.id){
                            editMenuAction(
                                params
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        onClose: () => {
                                            this.viewData.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        }else{
                            createMenuAction(
                                params
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        onClose: () => {
                                            this.viewData.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        }
                    }
                })
            }
        }
    }
</script>


<style lang="scss">
    .el-dialog__body {
        .org-dialog-form {
            width: 95%;
        }
    }
</style>